/**
 * Runtime environment detection based on hostname.
 * No separate builds needed — the same bundle works in all environments.
 */

export type Environment = 'local' | 'dev' | 'production'

export function detectEnvironment(): Environment {
  if (typeof window === 'undefined') {
    return 'local'
  }

  const hostname = window.location.hostname

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local'
  }

  if (hostname.endsWith('.dev.ponpon.ai') || hostname.endsWith('.pages.dev')) {
    return 'dev'
  }

  return 'production'
}

const API_BASE_MAP: Record<Environment, string> = {
  local: 'http://localhost:9000',
  dev: 'https://ponpon-api-ja2vnqtc2a-uc.a.run.app',
  production: 'https://ponpon-api-jre2s7ysta-uc.a.run.app',
}

export function getDefaultApiBase(): string {
  if (import.meta.env.VITE_API_BASE) {
    return import.meta.env.VITE_API_BASE
  }
  return API_BASE_MAP[detectEnvironment()]
}
